import subModuleKeys from '@/modules/constants/subModuleKeys';
import publicRoutesMetaData from '@/router/publicRoutes/publicRoutesMetaData';

const OldMediaModule = () => import(/* webpackChunkName: "oldmedia" */ '@/components/modules/salesTools/OldMediaModule.vue');
const ComfortPackageModule = () => import(/* webpackChunkName: "comfortpackage" */ '@/components/modules/salesTools/comfortPackage/ComfortPackageModule.vue');
const WebAdsModule = () => import(/* webpackChunkName: "webads" */ '@/components/modules/salesTools/webAds/WebAdsModule.vue');
const OutdoorAdsModule = () => import(/* webpackChunkName: "outdoorads" */ '@/components/modules/salesTools/outdoorAds/OutdoorAdsModule.vue');
const SocialSellingModule = () => import(/* webpackChunkName: "socialselling" */ '@/components/modules/salesTools/SocialSellingModule.vue');
const TrafficBoosterModule = () => import(/* webpackChunkName: "trafficbooster" */ '@/components/modules/salesTools/trafficBooster/TrafficBoosterModule.vue');
const ManualSalesModule = () => import(/* webpackChunkName: "manualsales" */ '@/components/modules/mail/ManualSalesModule.vue');
const EmailServicesModule = () => import(/* webpackChunkName: "emailservices" */ '@/components/modules/salesTools/EmailServicesModule.vue');
const FacebookAdsModule = () => import(/* webpackChunkName: "facebookads" */ '@/components/modules/salesTools/facebookAds/FacebookAdsModule.vue');

const eventSelectorWithCustomPlaceholder = (placeholderText) => {
  const webAdsInputComponent = publicRoutesMetaData.getEventInputComponents();
  webAdsInputComponent[0].props.eventSelectorPlaceholder = placeholderText;
  return webAdsInputComponent;
};

const subModules = {
  [subModuleKeys.WEB_ADS]: {
    component: WebAdsModule,
    name: subModuleKeys.WEB_ADS,
    path: '/ads/webads',
    props: { moduleKey: subModuleKeys.WEB_ADS },
    meta: {
      eventInputComponents: eventSelectorWithCustomPlaceholder('Välj vilket evenemang annonsen gäller'),
      postUrl: publicRoutesMetaData.getPostUrl('webads'),
    },
  },
  [subModuleKeys.OUTDOOR_ADS]: {
    component: OutdoorAdsModule,
    name: subModuleKeys.OUTDOOR_ADS,
    path: '/ads/outdoorads',
    props: { moduleKey: subModuleKeys.OUTDOOR_ADS },
    meta: {
      eventInputComponents: eventSelectorWithCustomPlaceholder('Välj vilket evenemang annonsen gäller'),
      postUrl: publicRoutesMetaData.getPostUrl('outdoorads'),
    },
  },
  [subModuleKeys.SOCIAL_SELLING]: {
    component: SocialSellingModule,
    name: subModuleKeys.SOCIAL_SELLING,
    path: '/socialmediaads/socialselling',
    props: { moduleKey: subModuleKeys.SOCIAL_SELLING },
    meta: {
      eventInputComponents: publicRoutesMetaData.getEventInputComponents(),
      postUrl: publicRoutesMetaData.getPostUrl('socialselling'),
    },
  },
  [subModuleKeys.TRAFFIC_BOOSTER]: {
    component: TrafficBoosterModule,
    name: subModuleKeys.TRAFFIC_BOOSTER,
    path: '/socialmediaads/trafficbooster',
    props: { moduleKey: subModuleKeys.TRAFFIC_BOOSTER },
    meta: {
      eventInputComponents: publicRoutesMetaData.getEventInputComponents(),
      postUrl: publicRoutesMetaData.getPostUrl('trafficbooster'),
    },
  },
  [subModuleKeys.MANUAL_SALES]: {
    component: ManualSalesModule,
    name: subModuleKeys.MANUAL_SALES,
    path: '/sales/manual',
    props: { moduleKey: subModuleKeys.MANUAL_SALES },
  },
  [subModuleKeys.EMAIL_SERVICES]: {
    component: EmailServicesModule,
    name: subModuleKeys.EMAIL_SERVICES,
    path: '/sales/emailservices',
    props: { moduleKey: subModuleKeys.EMAIL_SERVICES },
    meta: {
      eventInputComponents: publicRoutesMetaData.getEventInputComponents(),
    },
  },
  [subModuleKeys.OLD_MEDIA]: {
    component: OldMediaModule,
    name: subModuleKeys.OLD_MEDIA,
    path: '/sales/oldmedia',
    props: { moduleKey: subModuleKeys.OLD_MEDIA },
  },
  [subModuleKeys.COMFORT_PACKAGE]: {
    component: ComfortPackageModule,
    name: subModuleKeys.COMFORT_PACKAGE,
    path: '/sales/comfortpackage',
    props: { moduleKey: subModuleKeys.COMFORT_PACKAGE },
    meta: {
      postUrl: publicRoutesMetaData.getPostUrl('comfort'),
    },
  },
  [subModuleKeys.FACEBOOK_ADS]: {
    component: FacebookAdsModule,
    name: subModuleKeys.FACEBOOK_ADS,
    path: '/sales/facebookads',
    props: { moduleKey: subModuleKeys.FACEBOOK_ADS },
    meta: {
      eventInputComponents: publicRoutesMetaData.getEventInputComponents(),
      postUrl: publicRoutesMetaData.getPostUrl('facebookads'),
    },
  },
};

export default subModules;
